// extracted by mini-css-extract-plugin
export default {"container":"titleValue_container__KloLb","titleWrapper":"titleValue_titleWrapper__eraxM","valueWrapper":"titleValue_valueWrapper__-wg7D"};